import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["patientId", "indicationContainer", "sendReminderContainer", "returnSelectDiv", "returnMonthsContainer"];

  connect() {
    if (!this.indicationContainerTarget.classList.contains("tw-hidden")) {
      this.showIndicationField()
    }
    this.patientIdTarget.addEventListener('selected-patient', ({patient}) => {
      !patient.indication ? this.showIndicationField() : this.hideIndicationField();
    })
  }

  showIndicationField(){
    this.indicationContainerTarget.parentElement.classList.add("appointment-extra-fields--indication-active");
    this.indicationContainerTarget.classList.remove('tw-hidden')
  }

  hideIndicationField(){
    this.indicationContainerTarget.parentElement.classList.remove("appointment-extra-fields--indication-active");
    this.indicationContainerTarget.classList.add('tw-hidden')
  }
}
